import { render, staticRenderFns } from "./ProductInfo2.vue?vue&type=template&id=3b1e9c0c&"
import script from "./ProductInfo2.vue?vue&type=script&lang=js&"
export * from "./ProductInfo2.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfo2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports